import React from 'react';
import { Wrapper } from './styled';

const Android = () => {
	return (
		<Wrapper>
			<div className="popup-wrapper">
				<div className="top">
					<div onClickCapture={() => window.history.back()} className="back">
						<img src="/images/icon-popup-arrow.svg" alt="" />
					</div>
					<h2>전자명함 이용안내</h2>
				</div>
				<div className="noti">카카오톡 이용 중이신가요? </div>
				<h1>기본 브라우저로 접속해주세요</h1>
				<div className="box">
					<div className="flex">
						<div className="number">
							<p>1</p>
						</div>
						<p className="way">
							브라우저 하단 <span>메뉴 버튼</span> 탭
						</p>
					</div>
					<div className="imgbox"></div>
				</div>
				<div className="box">
					<div className="flex">
						<div className="number">
							<p>2</p>
						</div>
						<p className="way">
							<span>다른 브라우저로 열기</span> 선택
						</p>
					</div>
					<div className="imgbox imgbox2"></div>
				</div>
				<div className="box box2">
					<div className="flex">
						<div className="number">
							<p>3</p>
						</div>
						<p className="way">완료</p>
					</div>
				</div>
				<div className="here">
					<p> Here👇</p>
				</div>
			</div>
		</Wrapper>
	);
};

export default Android;
